import React from 'react'
import { InputAdornment, TextField } from '@mui/material'
import MonitizationOn from '@mui/icons-material/MonetizationOn'
import { budgetIsValid } from '../../../helpers/campaignForm.helpers'

type Props = {
  budget?: number
  setBudget: (Budget: number) => void
}

export const CampaignBudgetField = ({ budget, setBudget }: Props) => (
  <div className="w-full grid sm:grid-cols-3 gap-4 py-4 items-start">
    <p className="text-sm font-semibold text-mm-neutral-1-700">Campaign Budget</p>
    <TextField
      className="sm:col-span-2"
      type="number"
      required
      error={!budgetIsValid(budget)}
      helperText={budgetIsValid(budget) ? undefined : 'Must be over $50 and under $10,000'}
      label="Campaign Budget"
      placeholder="Campaign Budget"
      defaultValue={budget}
      variant="standard"
      onChange={({ target }) => {
        setBudget(Number(target.value))
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <MonitizationOn />
          </InputAdornment>
        ),
      }}
    />
  </div>
)
